import { createStore } from 'vuex'
import menu from "./modules/menu"
import layout from "./modules/layout"
import language from "./modules/language"
import auth from "./modules/auth"
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    menu,
    layout,
    language,
    auth
  }
})
